<template>
	<guest-template
		navHeaderTitle="Search Results"
		:showNavFooter="false"
		:showNavHeader="true"
	>
		<v-container class="search-results-page">
			<Search
				defaultWidth="380px"
				@search-results="handleSearchResults"
				:searchOnly="false"
				v-bind:institutions.sync="institutions"
				style="padding: 0px 10px"
				@error="handleError"
				:showMoreFilter="false"
				@no-results="handleNoResults"
				:defaultFilters="defaultFilters"
				breakpoint="xs"
			/>
			<SearchResultsList
				:totalResults="searchResults.nbHits"
				:totalPages="searchResults.nbPages"
				:currentPage="searchResults.page"
				:queryID="searchResults.queryID"
				v-bind:institutions.sync="institutions"
				@searchDetails="viewDetails"
				:loading="loading"
				:error="error"
				:noResults="noResults"
				breakpoint="xs"
			/>
		</v-container>
	</guest-template>
</template>

<script>
import guestTemplate from '../../templates/guestTemplate.vue'
import { getUrlParams } from '../../utilities'

export default {
	components: { guestTemplate },
	name: 'ResultsView',
	data: () => ({
		institutions: [],
		searchResults: {
			nbHits: 0,
			nbPages: 0,
			page: 0
		},
		defaultFilters: {
			category: null,
			subcategory: null,
			location: {
				city: null,
				state: null
			},
			zip: null,
			partner: null,
			query: null
		},
		loading: false,
		error: null,
		noResults: false
	}),
	methods: {
		viewDetails(inst) {
			// if npm.buildpipe === component
			// this.$root.$emit(inst.uuid)
			this.$router.push({
				name: 'details',
				props: { uuid: inst.uuid },
				params: { uuid: inst.uuid, inst }
			})
		},
		handleLoading(v) {
			this.loading = v
		},
		handleError(v) {
			this.error = v
		},
		handleNoResults(v) {
			this.noResults = v
		},
		handleSearchResults(v) {
			this.searchResults = v
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.$root.$on('loading', (loading) => (this.loading = loading))

			if (this.$route.params) {
				this.defaultFilters = {
					...this.defaultFilters,
					...this.$route.params
				}
			}
			const params = getUrlParams(window.location.hash)
			let paramKeys = Object.keys(params)
			const validParams = paramKeys.filter(
				(param) =>
					Object.keys(this.$route.meta).includes(param) && param
			)
			if (validParams.length > 0) {
				for (const key of validParams) {
					this.defaultFilters[key] = params[key]
				}
			}
		})
	}
}
</script>
<style lang="scss" scoped>
@import '../../styles/typography-screen';

.search-results-page {
	min-height: 100vh;
	background-color: $white;
	padding-top: 42px;
	padding-left: 0px;
	padding-right: 0px;
	.list-view {
		min-width: auto !important;
	}
}

.search-results-page::v-deep .search-wrapper {
	padding: 0px 12px 0px 12px !important;
}

.search-results-page::v-deep .list-view {
	padding: 12px 24px 12px 24px !important;
}
</style>
